import uuidv1 from 'uuid/v1';
import  { getCountry } from 'utils/utils';

const getScope = (country) => {
  switch(country) {
    case 'HN':
      return 'pos';
    case 'GT':
    case 'PY':
    case 'NI':
      return 'pha';
    default:
      return 'poa'
  }
}

const getOpenId = (country) => {
  switch(country) {
    case 'GT':
    case 'PY':
    case 'NI':
      return 'phone';
    default:
      return 'mobileId'
  }
}

export const tigoLogin = (netCodeURL, redirectURL, codeVerifier, clientId) => {
  const country = getCountry();
  const state = uuidv1();
  localStorage.setItem('TIGOPOASTATE', state);
  const nonce = uuidv1();
  const code = `${codeVerifier}`;
  const scope = getScope(country);
  const openId = getOpenId(country);
  const url = `${netCodeURL}/oauth/v2/authorize?response_type=code&redirect_uri=${redirectURL}&client_id=${clientId}&scope=openid ${openId} ${scope}&state=${state}&nonce=${nonce}&code_challenge=${code}&code_challenge_method=S256`;
  window.location.href = url;
};
